import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import themeStyles from './AdditionalWarranty.styles';
import { useLanguage } from '../../utils/sitecoreContext';
import AddToBuildButton from '../AddToBuildButton';

const Card = themeStyles.apply(Box, 'Card');
const Title = themeStyles.apply(Copy, 'Title');
const WarrantyTerm = themeStyles.apply(Copy, 'WarrantyTerm');
const MSRPCopy = themeStyles.apply(Copy, 'MSRPCopy');

const AdditionalWarrantyCard = ({ title, price, name, isSelected, onClickEvent, isSingle }) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const precision = 2;

  return (
    <Card
      as="button"
      tabIndex="0"
      onClick={onClickEvent}
      isSingle={isSingle}
      isSelected={isSelected}
      data-testid="cy-additional-warranty-card"
    >
      <Title data-testid="cy-additional-warranty-title">{title}</Title>
      <WarrantyTerm data-testid="cy-additional-warranty-name">{name}</WarrantyTerm>
      <MSRPCopy data-testid="cy-additional-warranty-price">{`${formatPrice(price, language, precision)} ${t(
        'Sub-apps.PriceAndFinance.msrpLabel',
      )}`}</MSRPCopy>
      <AddToBuildButton isOnBuild={isSelected} />
    </Card>
  );
};

AdditionalWarrantyCard.propTypes = {
  title: PropTypes.string,
  price: PropTypes.number,
  name: PropTypes.string,
  isSelected: PropTypes.bool,
  isSingle: PropTypes.bool,
  onClickEvent: PropTypes.func,
};

export default AdditionalWarrantyCard;
